import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// What a page, table or dialog shows when a search brings nothing back
export default function NoDataFound({ title = 'No data found', text = 'No results for these parameters. Try again with other values.', sx = {} }) {
	const { span, ...boxSx } = sx

	return <Box sx={{
		display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, textAlign: 'center',
		px: 2.5, py: 5.5, borderRadius: '12px', border: `1px dashed ${dsColorNew.grayBorder}`, backgroundColor: dsColorNew.white,
		...boxSx,
	}}>
		<Box sx={{
			width: 44, height: 44, mb: 0.5, borderRadius: '12px',
			display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
			backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue,
		}}>
			<IconSeeker icon="magnifying-glass-chart" sx={{ fontSize: 18 }}/>
		</Box>
		<Typography sx={{ fontSize: 15, fontWeight: 600, color: dsColorNew.textTitle }}>{title}</Typography>
		{!!text && <Typography sx={{ fontSize: 13, color: dsColorNew.textMuted, maxWidth: 360, lineHeight: 1.45 }}>{text}</Typography>}
	</Box>
}
